import { render, staticRenderFns } from "./NavigationItems.vue?vue&type=template&id=2089e8e3&"
import script from "./NavigationItems.vue?vue&type=script&lang=js&"
export * from "./NavigationItems.vue?vue&type=script&lang=js&"
import style0 from "./NavigationItems.vue?vue&type=style&index=0&id=2089e8e3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports